'use client';

import { createToaster } from '@chakra-ui/react';

// Export the toaster instance
export const toaster = createToaster({
  placement: 'bottom',
  pauseOnPageIdle: true,
});

// Export the utility function
export const getToastBgColor = (type?: string) => {
  switch (type) {
    case 'success':
      return 'green.100'; // or any custom color you prefer
    case 'error':
      return 'red.100';
    case 'info':
      return 'blue.100';
    case 'warning':
      return 'orange.100';
    case 'loading':
      return 'neutral.50';
    default:
      return 'white';
  }
};
